import { ENABLE_QR_OUTDATED_CHECK } from "components/events/helpers/event-check-qr-policy";


export const STAFF_CHECK_QR_STATUS = Object.freeze({
    MISSING: "missing",
    READY: "ready",
    OUTDATED: "outdated",
    GENERATING: "generating",
    REGENERATING: "regenerating",
    GENERATION_FAILED: "generation_failed",
    REGENERATION_FAILED: "regeneration_failed",
});


export const getStaffCheckQrBaseStatus = ({
    qrUrl,
    hasValidLocation,
    generatedCoordinatesKey,
    currentCoordinatesKey,
    isOutdatedStatusEnabled = ENABLE_QR_OUTDATED_CHECK,
}) => {
    if (!qrUrl)
    {
        return STAFF_CHECK_QR_STATUS.MISSING;
    }

    if (
        isOutdatedStatusEnabled && (
            !hasValidLocation ||
            (
                generatedCoordinatesKey &&
                generatedCoordinatesKey !== currentCoordinatesKey
            )
        )
    )
    {
        return STAFF_CHECK_QR_STATUS.OUTDATED;
    }

    return STAFF_CHECK_QR_STATUS.READY;
};

export const resolveStaffCheckQrStatus = (baseStatus, operationStatus) => {
    if ([
        STAFF_CHECK_QR_STATUS.GENERATING,
        STAFF_CHECK_QR_STATUS.REGENERATING,
    ].includes(operationStatus))
    {
        return operationStatus;
    }

    if (baseStatus === STAFF_CHECK_QR_STATUS.READY)
    {
        return operationStatus === STAFF_CHECK_QR_STATUS.REGENERATION_FAILED ?
            operationStatus : STAFF_CHECK_QR_STATUS.READY;
    }

    if (
        baseStatus === STAFF_CHECK_QR_STATUS.MISSING &&
        [
            STAFF_CHECK_QR_STATUS.GENERATING,
            STAFF_CHECK_QR_STATUS.GENERATION_FAILED,
        ].includes(operationStatus)
    )
    {
        return operationStatus;
    }

    if (
        baseStatus === STAFF_CHECK_QR_STATUS.OUTDATED &&
        [
            STAFF_CHECK_QR_STATUS.REGENERATING,
            STAFF_CHECK_QR_STATUS.REGENERATION_FAILED,
        ].includes(operationStatus)
    )
    {
        return operationStatus;
    }

    return baseStatus;
};

export const isStaffCheckQrLoading = (status) => [
    STAFF_CHECK_QR_STATUS.GENERATING,
    STAFF_CHECK_QR_STATUS.REGENERATING,
].includes(status);

export const isStaffCheckQrFailed = (status) => [
    STAFF_CHECK_QR_STATUS.GENERATION_FAILED,
    STAFF_CHECK_QR_STATUS.REGENERATION_FAILED,
].includes(status);
